module.exports = __webpack_public_path__ + "static/media/yoda.ddb70031.gif";